import { render, staticRenderFns } from "./touzi.vue?vue&type=template&id=212465f0&scoped=true&"
import script from "./touzi.vue?vue&type=script&lang=js&"
export * from "./touzi.vue?vue&type=script&lang=js&"
import style0 from "./touzi.vue?vue&type=style&index=0&id=212465f0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212465f0",
  null
  
)

export default component.exports